import React from "react";
import {Link} from "react-router-dom";
import style from './404.module.css'
import {ru} from "../data/ru"
import {by} from "../data/by"

export default function NotFoundPage() {
    let language = localStorage.getItem('lang') === 'ru' ? ru.error : by.error
    return (
        <div className={style.errorContainer}>
            <div className={style.returnBlock}>
                <Link to="/" className={style.return}>{language.errReturn}</Link>
            </div>
            <div>
                <h1 className={style.error} data-text="404">404</h1>
            </div>
            <div>
                <h2 className={style.notFound}> {language.notFound}</h2>
            </div>
        </div>
    )
}
